
// @ts-nocheck


export const localeCodes =  [
  "en",
  "es",
  "es-mx",
  "pt",
  "pt-br",
  "de",
  "fr",
  "it"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.json", load: () => import("../locales/en.json" /* webpackChunkName: "locale__vercel_path0_locales_en_json" */), cache: true },
{ key: "../locales/scor_en.json", load: () => import("../locales/scor_en.json" /* webpackChunkName: "locale__vercel_path0_locales_scor_en_json" */), cache: true },
{ key: "../locales/old.json", load: () => import("../locales/old.json" /* webpackChunkName: "locale__vercel_path0_locales_old_json" */), cache: true }],
  "es": [{ key: "../locales/es.json", load: () => import("../locales/es.json" /* webpackChunkName: "locale__vercel_path0_locales_es_json" */), cache: true },
{ key: "../locales/old.json", load: () => import("../locales/old.json" /* webpackChunkName: "locale__vercel_path0_locales_old_json" */), cache: true }],
  "es-mx": [{ key: "../locales/es_MX.json", load: () => import("../locales/es_MX.json" /* webpackChunkName: "locale__vercel_path0_locales_es_MX_json" */), cache: true },
{ key: "../locales/old.json", load: () => import("../locales/old.json" /* webpackChunkName: "locale__vercel_path0_locales_old_json" */), cache: true }],
  "pt": [{ key: "../locales/pt_PT.json", load: () => import("../locales/pt_PT.json" /* webpackChunkName: "locale__vercel_path0_locales_pt_PT_json" */), cache: true },
{ key: "../locales/old.json", load: () => import("../locales/old.json" /* webpackChunkName: "locale__vercel_path0_locales_old_json" */), cache: true }],
  "pt-br": [{ key: "../locales/pt_BR.json", load: () => import("../locales/pt_BR.json" /* webpackChunkName: "locale__vercel_path0_locales_pt_BR_json" */), cache: true },
{ key: "../locales/old.json", load: () => import("../locales/old.json" /* webpackChunkName: "locale__vercel_path0_locales_old_json" */), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => import("../locales/de.json" /* webpackChunkName: "locale__vercel_path0_locales_de_json" */), cache: true },
{ key: "../locales/old.json", load: () => import("../locales/old.json" /* webpackChunkName: "locale__vercel_path0_locales_old_json" */), cache: true }],
  "fr": [{ key: "../locales/fr_FR.json", load: () => import("../locales/fr_FR.json" /* webpackChunkName: "locale__vercel_path0_locales_fr_FR_json" */), cache: true },
{ key: "../locales/old.json", load: () => import("../locales/old.json" /* webpackChunkName: "locale__vercel_path0_locales_old_json" */), cache: true }],
  "it": [{ key: "../locales/it_IT.json", load: () => import("../locales/it_IT.json" /* webpackChunkName: "locale__vercel_path0_locales_it_IT_json" */), cache: true },
{ key: "../locales/old.json", load: () => import("../locales/old.json" /* webpackChunkName: "locale__vercel_path0_locales_old_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "files": [
        "/vercel/path0/locales/en.json",
        "/vercel/path0/locales/scor_en.json",
        "/vercel/path0/locales/old.json"
      ],
      "domainDefault": true
    },
    {
      "code": "es",
      "files": [
        "/vercel/path0/locales/es.json",
        "/vercel/path0/locales/old.json"
      ],
      "domainDefault": true
    },
    {
      "code": "es-mx",
      "files": [
        "/vercel/path0/locales/es_MX.json",
        "/vercel/path0/locales/old.json"
      ]
    },
    {
      "code": "pt",
      "files": [
        "/vercel/path0/locales/pt_PT.json",
        "/vercel/path0/locales/old.json"
      ],
      "domainDefault": true
    },
    {
      "code": "pt-br",
      "files": [
        "/vercel/path0/locales/pt_BR.json",
        "/vercel/path0/locales/old.json"
      ]
    },
    {
      "code": "de",
      "files": [
        "/vercel/path0/locales/de.json",
        "/vercel/path0/locales/old.json"
      ]
    },
    {
      "code": "fr",
      "files": [
        "/vercel/path0/locales/fr_FR.json",
        "/vercel/path0/locales/old.json"
      ]
    },
    {
      "code": "it",
      "files": [
        "/vercel/path0/locales/it_IT.json",
        "/vercel/path0/locales/old.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": true,
  "langDir": "locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "fallbackLocale": "en",
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "files": [
      {
        "path": "/vercel/path0/locales/en.json"
      },
      {
        "path": "/vercel/path0/locales/scor_en.json"
      },
      {
        "path": "/vercel/path0/locales/old.json"
      }
    ],
    "domainDefault": true
  },
  {
    "code": "es",
    "files": [
      {
        "path": "/vercel/path0/locales/es.json"
      },
      {
        "path": "/vercel/path0/locales/old.json"
      }
    ],
    "domainDefault": true
  },
  {
    "code": "es-mx",
    "files": [
      {
        "path": "/vercel/path0/locales/es_MX.json"
      },
      {
        "path": "/vercel/path0/locales/old.json"
      }
    ]
  },
  {
    "code": "pt",
    "files": [
      {
        "path": "/vercel/path0/locales/pt_PT.json"
      },
      {
        "path": "/vercel/path0/locales/old.json"
      }
    ],
    "domainDefault": true
  },
  {
    "code": "pt-br",
    "files": [
      {
        "path": "/vercel/path0/locales/pt_BR.json"
      },
      {
        "path": "/vercel/path0/locales/old.json"
      }
    ]
  },
  {
    "code": "de",
    "files": [
      {
        "path": "/vercel/path0/locales/de.json"
      },
      {
        "path": "/vercel/path0/locales/old.json"
      }
    ]
  },
  {
    "code": "fr",
    "files": [
      {
        "path": "/vercel/path0/locales/fr_FR.json"
      },
      {
        "path": "/vercel/path0/locales/old.json"
      }
    ]
  },
  {
    "code": "it",
    "files": [
      {
        "path": "/vercel/path0/locales/it_IT.json"
      },
      {
        "path": "/vercel/path0/locales/old.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
